import Helpers from '~/modules/Helpers.js';
import { resolveLegacyLocale } from '~/modules/legacyI18n.js';
import legacyEventHub from '~/modules/legacyRuntime.js';

function checkboxDropdownLocale() {
    return resolveLegacyLocale();
}

function checkboxDropdownText(germanText, englishText) {
    return checkboxDropdownLocale() === 'de' ? germanText : englishText;
}

const CheckboxDropdown = function (element, config) {

    var _defaultConfig;

    _defaultConfig = {
        toggleClass: 'checkbox-dropdown--visible',
        unselectAllSelector: '[data-action~=checkboxDropdownUnselectAll]',
        // internals
        beforeMount: function () {
            // instance is available as instance parameter
        },
        afterMount: function () {
            // instance is available as instance parameter
        }
    };
    if (element && element.nodeType === 1) {
        this.dropdownContainer = element;
    } else {
        throw new Error('linkNode for Checkbox Dropdown was invalid or not of the correct type');
    }

    this.originalSwitchLabel = undefined;

    this.config = Helpers.createConfigObject(config, _defaultConfig);

    this._init();
};

CheckboxDropdown.prototype._init = function () {
    this.config.beforeMount(this);

    if (this.dropdownContainer) {
        this.searchEnabled = this.dropdownContainer.dataset.checkboxDropdownSearch === 'true' || this.dropdownContainer.classList.contains('checkbox-dropdown--track-categorization');
        this.searchInputElement = null;
        this.selectedHeadingElement = null;
        this.unselectElement = this.dropdownContainer.querySelector(this.config.unselectAllSelector);
        this.originalSwitchLabel = this.dropdownContainer.querySelector('.checkbox-dropdown__switch-counter').getAttribute('data-checkbox-dropdown-label');
        this.optionRows = Array.from(this.dropdownContainer.querySelectorAll('.checkbox-dropdown__checkboxes .checkbox'));
        this._captureOriginalOrder();
        this._mountSearch();
        this._mountSelectedHeading();
        this.refresh();
        this._addEventListeners();
    }

    this.config.afterMount(this);
};

CheckboxDropdown.prototype.refresh = function () {
    this._updateSwitchLabel();
    this._syncSelectedGroup();
    this._filterOptions(this.searchInputElement ? this.searchInputElement.value : '');
};

CheckboxDropdown.prototype._updateSwitchLabel = function () {
    var activeElements = this.dropdownContainer.querySelectorAll('input[type=checkbox]:checked');

    if (activeElements.length === 0) {
        this.dropdownContainer.querySelector('.checkbox-dropdown__switch-counter').innerHTML = this.originalSwitchLabel;
    } else {
        if (activeElements.length === 1) {
            this.dropdownContainer.querySelector('.checkbox-dropdown__switch-counter').innerHTML = activeElements.length + ' ' + checkboxDropdownText(' Option ausgewählt', ' option selected');
        } else {
            this.dropdownContainer.querySelector('.checkbox-dropdown__switch-counter').innerHTML = activeElements.length + ' ' + checkboxDropdownText(' Optionen ausgewählt', ' options selected');
        }

    }
};

CheckboxDropdown.prototype._mountSearch = function () {
    if (!this.searchEnabled) {
        return;
    }

    var checkboxesContainer = this.dropdownContainer.querySelector('.checkbox-dropdown__checkboxes');
    if (!checkboxesContainer || checkboxesContainer.querySelector('.checkbox-dropdown__search')) {
        return;
    }

    var searchWrapper = document.createElement('div');
    searchWrapper.className = 'checkbox-dropdown__search';

    var searchInput = document.createElement('input');
    searchInput.type = 'text';
    searchInput.className = 'checkbox-dropdown__search-input';
    searchInput.placeholder = this.dropdownContainer.dataset.checkboxDropdownSearchPlaceholder || checkboxDropdownText('Suchen', 'Search');

    searchWrapper.appendChild(searchInput);
    checkboxesContainer.insertBefore(searchWrapper, checkboxesContainer.firstChild);
    this.searchInputElement = searchInput;
};

CheckboxDropdown.prototype._captureOriginalOrder = function () {
    if (!this.optionRows) return;

    this.optionRows.forEach(function (row, index) {
        row.dataset.checkboxDropdownOriginalIndex = String(index + 1);
    });
};

CheckboxDropdown.prototype._mountSelectedHeading = function () {
    var checkboxesContainer = this.dropdownContainer.querySelector('.checkbox-dropdown__checkboxes');
    if (!checkboxesContainer || checkboxesContainer.querySelector('.checkbox-dropdown__selected-heading')) {
        return;
    }

    var selectedHeading = document.createElement('div');
    selectedHeading.className = 'checkbox-dropdown__selected-heading hide-element';
    selectedHeading.textContent = checkboxDropdownText('Ausgewählt', 'Selected');

    if (this.searchInputElement && this.searchInputElement.parentElement) {
        this.searchInputElement.parentElement.insertAdjacentElement('afterend', selectedHeading);
    } else {
        checkboxesContainer.insertBefore(selectedHeading, checkboxesContainer.firstChild);
    }

    this.selectedHeadingElement = selectedHeading;
};

CheckboxDropdown.prototype._syncSelectedGroup = function () {
    if (!this.optionRows || this.optionRows.length === 0) return;

    var selectedCount = 0;
    this.optionRows.forEach(function (row) {
        var checkbox = row.querySelector('input[type=checkbox]');
        var checked = !!(checkbox && checkbox.checked);
        var originalIndex = parseInt(row.dataset.checkboxDropdownOriginalIndex || '0', 10);

        row.classList.toggle('checkbox--selected', checked);
        if (checked) {
            selectedCount += 1;
            row.style.order = String(10 + selectedCount);
        } else {
            row.style.order = String(1000 + (isNaN(originalIndex) ? 0 : originalIndex));
        }
    });

    if (this.selectedHeadingElement) {
        this.selectedHeadingElement.classList.toggle('hide-element', selectedCount === 0);
    }
};

CheckboxDropdown.prototype._filterOptions = function (query) {
    if (!this.searchEnabled) {
        return;
    }

    var normalizedQuery = (query || '').toLowerCase().trim();

    this.dropdownContainer.querySelectorAll('.checkbox-dropdown__checkboxes .checkbox').forEach(function (optionRow) {
        var checkbox = optionRow.querySelector('input[type=checkbox]');
        var isChecked = checkbox && checkbox.checked;
        var searchableText = (optionRow.textContent || '').toLowerCase();
        var shouldShow = normalizedQuery.length === 0 || searchableText.indexOf(normalizedQuery) >= 0 || isChecked;

        optionRow.style.display = shouldShow ? '' : 'none';
    });
};

CheckboxDropdown.prototype._resetSearch = function () {
    if (!this.searchEnabled || !this.searchInputElement) {
        return;
    }

    this.searchInputElement.value = '';
    this._filterOptions('');
};

CheckboxDropdown.prototype._scrollOptionsToTop = function () {
    var optionsContainer = this.dropdownContainer.querySelector('.checkbox-dropdown__checkboxes');
    if (!optionsContainer) return;
    optionsContainer.scrollTop = 0;
};

CheckboxDropdown.prototype._visibleCheckboxInputs = function () {
    return Array.from(this.dropdownContainer.querySelectorAll('.checkbox-dropdown__checkboxes .checkbox input[type=checkbox]')).filter(function (input) {
        var row = input.closest('.checkbox');
        return !!(row && row.style.display !== 'none');
    });
};

CheckboxDropdown.prototype._focusVisibleCheckboxAt = function (index) {
    var inputs = this._visibleCheckboxInputs();
    if (inputs.length === 0) return;

    var targetIndex = Math.max(0, Math.min(index, inputs.length - 1));
    var targetInput = inputs[targetIndex];
    targetInput.focus();
    if (targetInput.scrollIntoView) {
        targetInput.scrollIntoView({ block: 'nearest' });
    }
};

CheckboxDropdown.prototype._addEventListeners = function () {
    legacyEventHub.on('closeAllDropdowns', function (data) {
        var originDropdownContainerElement = data[0];
        if (originDropdownContainerElement !== this.dropdownContainer) {
            this.dropdownContainer.classList.remove(this.config.toggleClass);
            this._resetSearch();
        }
    }.bind(this));

    legacyEventHub.on('closePopupMenus', function (data) {
        this.dropdownContainer.classList.remove(this.config.toggleClass);
        this._resetSearch();
    }.bind(this));


    this.dropdownContainer.querySelector('.checkbox-dropdown__switch').addEventListener('click', function (e) {
        e.preventDefault();

        legacyEventHub.trigger('closeAllDropdowns', this.dropdownContainer);

        // setTimeout(function () {
        if (this.dropdownContainer.classList.contains(this.config.toggleClass)) {
            // still open
            this.dropdownContainer.classList.remove(this.config.toggleClass);
            this._resetSearch();
        } else {
            // closed
            this.dropdownContainer.classList.add(this.config.toggleClass);
            this._resetSearch();
            this._scrollOptionsToTop();
            if (this.searchInputElement) {
                setTimeout(function () { this.searchInputElement.focus(); }.bind(this), 0);
            }
        }
        // }.bind(this), 10)
    }.bind(this));

    this.dropdownContainer.querySelector('.checkbox-dropdown__checkboxes').addEventListener('click', function (e) {
        this.refresh();
    }.bind(this));

    this.dropdownContainer.querySelector('.checkbox-dropdown__checkboxes').addEventListener('change', function (e) {
        this.refresh();
    }.bind(this));

    this.dropdownContainer.addEventListener('checkboxDropdownRefresh', function () {
        this.refresh();
    }.bind(this));

    if (this.searchInputElement) {
        this.searchInputElement.addEventListener('click', function (e) {
            e.stopPropagation();
        });
        this.searchInputElement.addEventListener('input', function (e) {
            this._filterOptions(e.target.value);
        }.bind(this));
        this.searchInputElement.addEventListener('keydown', function (e) {
            if (e.key === 'ArrowDown') {
                e.preventDefault();
                this._focusVisibleCheckboxAt(0);
            } else if (e.key === 'ArrowUp') {
                e.preventDefault();
                var inputs = this._visibleCheckboxInputs();
                this._focusVisibleCheckboxAt(inputs.length - 1);
            }
        }.bind(this));
    }

    this.dropdownContainer.querySelector('.checkbox-dropdown__checkboxes').addEventListener('keydown', function (e) {
        var activeInput = e.target.closest('input[type=checkbox]');
        if (!activeInput) return;

        var inputs = this._visibleCheckboxInputs();
        var currentIndex = inputs.indexOf(activeInput);
        if (currentIndex === -1) return;

        if (e.key === 'ArrowDown') {
            e.preventDefault();
            this._focusVisibleCheckboxAt(currentIndex + 1);
            return;
        }

        if (e.key === 'ArrowUp') {
            e.preventDefault();
            if (currentIndex === 0 && this.searchInputElement) {
                this.searchInputElement.focus();
                return;
            }
            this._focusVisibleCheckboxAt(currentIndex - 1);
            return;
        }

        if (e.key === 'Enter') {
            e.preventDefault();
            activeInput.click();
        }
    }.bind(this));

    if (this.unselectElement) {
        this.unselectElement.addEventListener('click', function(e) {
            var checkedElements = this.dropdownContainer.querySelectorAll('input[type=checkbox]:checked');
            
            e.preventDefault();

            checkedElements.forEach(function(element) {
                element.checked = false;
            })
            this._updateSwitchLabel();
            this._syncSelectedGroup();
            this._filterOptions(this.searchInputElement ? this.searchInputElement.value : '');
        }.bind(this))
    }
};

export default CheckboxDropdown;
